import { FlagStrip } from "@/components/Brand";
import { useAuth, primaryRole } from "@/context/AuthContext";
import { ROLE_THEME } from "@/lib/brand";

// Role-branded banner sitting at the top of each staff console (teller, cashier, station, admin, management).
export default function ConsoleHeader({ title, subtitle, icon: Icon, role: roleProp, right }) {
  const { user } = useAuth();
  const role = roleProp || primaryRole(user) || "teller";
  const theme = ROLE_THEME[role] || ROLE_THEME.teller;
  return (
    <div className="card-soft overflow-hidden" data-testid="console-header">
      <div className="h-1 w-full" style={{ background: theme.accent }} />
      <div className="flex flex-col gap-3 p-4 sm:flex-row sm:items-center sm:justify-between sm:p-5">
        <div className="flex items-center gap-3">
          <span className={`grid h-11 w-11 shrink-0 place-items-center rounded-2xl ${theme.soft} ${theme.text}`}>
            {Icon ? <Icon className="h-5 w-5" /> : null}
          </span>
          <div className="min-w-0">
            <div className={`text-[11px] font-bold uppercase tracking-[0.18em] ${theme.text}`} data-testid="console-role-label">{theme.label}</div>
            <div className="truncate font-display text-xl font-extrabold tracking-tight text-slate-900 sm:text-2xl" data-testid="console-title">{title}</div>
            {subtitle ? <div className="text-sm text-slate-500" data-testid="console-subtitle">{subtitle}</div> : null}
          </div>
        </div>
        {right ? <div className="flex items-center gap-2">{right}</div> : null}
      </div>
      <FlagStrip className="h-[3px]" />
    </div>
  );
}
